import { useToggleState } from '@cian/react-utils';
import { plural } from '@cian/utils';

import { clsx } from 'clsx';
import { FC, useMemo } from 'react';

import { CollapsedButton } from '../CollapsedButton';
import { FlexOffice } from '../FlexOffice';

import { IFlexOfficeList } from './types';

import * as styles from './styles.css';

export const FlexOfficeList: FC<IFlexOfficeList> = props => {
  const { className, offers, selectedOfferId } = props;

  const { state: isCollapsed, toggle: toggleCollapsed } = useToggleState(true);

  const [offersBeforeCut, offersUnderCut] = useMemo(() => {
    if (offers.length > 3) {
      return [offers.slice(0, 3), offers.slice(3)];
    }

    return [offers, []];
  }, [offers]);

  const buttonText = useMemo(() => {
    const offersCount = offersUnderCut.length;

    if (!offersCount) {
      return '';
    }

    return `Ещё ${offersCount} ${plural(offersCount, ['вариант', 'варианта', 'вариантов'])}`;
  }, [offersUnderCut]);

  return (
    <div className={clsx(className)}>
      {offersBeforeCut.map(offer => (
        <FlexOffice {...offer} key={offer.id} selectedOfferId={selectedOfferId} />
      ))}
      {!isCollapsed && offersUnderCut.map(offer => <FlexOffice {...offer} key={offer.id} />)}
      {Boolean(offersUnderCut.length) && (
        <CollapsedButton className={styles['button']} isCollapsed={isCollapsed} onClick={toggleCollapsed}>
          {buttonText}
        </CollapsedButton>
      )}
    </div>
  );
};

FlexOfficeList.displayName = 'FlexOfficeList';
